// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--34MNh";
export var notice = "layout-module--notice--YMnMZ";
export var screenreader = "layout-module--screenreader--YlNzQ";
export var wrapper = "layout-module--wrapper--0eHWm";